import React from 'react';
import { AppError, getErrorMessage } from '../utils/errorHandler';

interface ErrorMessageProps {
  error: AppError | string | null;
  onRetry?: () => void;
  className?: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ 
  error, 
  onRetry, 
  className = '' 
}) => {
  if (!error) return null;

  const message = typeof error === 'string' ? error : getErrorMessage(error);
  const showRetry = onRetry && (typeof error !== 'string');

  return (
    <div className={`bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded ${className}`}>
      <div className="flex items-start">
        <div className="flex-1">
          <div className="font-medium">エラーが発生しました</div>
          <div className="mt-1 text-sm whitespace-pre-line">{message}</div>
        </div>
        {showRetry && (
          <button
            onClick={onRetry}
            className="ml-4 bg-red-600 text-white px-3 py-1 rounded text-sm hover:bg-red-700"
          >
            再試行
          </button>
        )}
      </div>
    </div>
  );
};
